import React from 'react';
import {BackTop} from 'antd';
export default class checkFooter extends React.Component {
    constructor(props){
        super(props);
        this.state={
            yearCurrent:'',
        }
    }
    componentDidMount(){
		var copyright = new Date();                 //取得当前的日期
        var yearCurrent = copyright.getFullYear();
        this.setState({
            yearCurrent:yearCurrent
        })
	}
    render() {
        // const {
        //     yearCurrent
        // } = this.state;
        return (
            <div className="footer">
                <div className="bottom">
                    <div className="inner">
                        <div className="nav">
                            <a href="/">联系我们</a><span>|</span> 
                            <a href="/">加入我们</a><span>|</span>  
                            <a href="/">在线留言</a><span>|</span>
                            <a href="/">帮助中心</a>
                        </div>
                        <div className="rights">京ICP备17041952号-2&nbsp;&nbsp;|&nbsp;&nbsp;Copyright&copy;{'2019'} 北京搜知数据科技有限公司 版权所有</div>
                    </div>
                </div>
                <div className="urgent-service">
                    <a target="_blank" rel="noopener noreferrer" href="http://chat10.live800.com/live800/chatClient/chatbox.jsp?companyID=448316&jid=6318557147&enterurl=http%3A%2F%2Fwww%2Eepsnet%2Ecom%2Ecn%2Fch%2FSys%2FReportPage%2Easpx%3FKey%3D230%26Type%3DKE%5FCLASS%5FEXPRESSREPORT&timestamp=1344843114447&pagereferrer=" title="在线客服">
                        <i className="icon_hg ico-service"></i>
                        <div className="name">客服</div>
                    </a>
                    {/* <a target="_blank" rel="noopener noreferrer" href="http://wpa.qq.com/msgrd?v=3&amp;uin=847252027&amp;site=qq&amp;menu=yes" title="在线客服">
                        <i className="icon_hg ico-service"></i>
                        <div className="name">客服</div>
                    </a> */}
                </div>
                <BackTop>
                    <div className="backup" title="返回顶部"><i className="icon_hg ico-up"></i></div>
                </BackTop>
            </div>
        );
    }
}